module.exports = __webpack_public_path__ + "img/fontShadowColor.34155127.svg";